import { Form, Input, InputNumber, Spin } from "antd";
import React from "react";
import { useForm } from "antd/lib/form/Form";
import { Locale } from "../../../utils";
import TranslateBtn from "../../../components/product/TranslateBtn";

const i18n = Locale.getInstance();

const AddOrEditVideoCategory = React.forwardRef(({ loading }, ref) => {
  const [categoryForm] = useForm();

  const updateFields = (item, value) => {
    const formDispatch = categoryForm.getInternalHooks(
      "RC_FORM_INTERNAL_HOOKS"
    ).dispatch;
    formDispatch({
      type: "updateValue",
      namePath: item,
      value,
    });
  };

  if (loading) {
    return <Spin spinning={loading} />;
  }

  return (
    <Form
      ref={ref}
      form={categoryForm}
      className="video-category-form"
      name="video-category"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 20 }}
      autoComplete="off"
    >
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => (
          <Form.Item
            name="ug_name"
            label={i18n.t("course.category.ugName")}
            rules={[
              {
                required: true,
                message: i18n.t("productEdit.standardRequired"),
              },
            ]}
          >
            <Input
              addonAfter={
                <TranslateBtn
                  context={getFieldValue("ug_name")}
                  onFinish={(value) => updateFields("zh_name", value)}
                  from="ug"
                  to="zh"
                />
              }
            />
          </Form.Item>
        )}
      </Form.Item>

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => (
          <Form.Item
            name="zh_name"
            label={i18n.t("course.category.zhName")}
            rules={[
              {
                required: true,
                message: i18n.t("productEdit.standardRequired"),
              },
            ]}
          >
            <Input
              addonAfter={
                <TranslateBtn
                  context={getFieldValue("zh_name")}
                  onFinish={(value) => updateFields("ug_name", value)}
                  from="zh"
                  to="ug"
                />
              }
            />
          </Form.Item>
        )}
      </Form.Item>

      <Form.Item
        name="order"
        label={i18n.t("shows.sortTypesTitle")}
        initialValue={0}
      >
        <InputNumber style={{ width: "100%" }} min={0} />
      </Form.Item>
    </Form>
  );
});

export default AddOrEditVideoCategory;
